import { BusinessDetailsFields } from '@/components/Chat/BusinessDetailsFields'
import { OwnerInfoFields } from '@/components/Chat/OwnerInfoFields'
import { TravelDistanceFields } from '@/components/Chat/TravelDistanceFields'
import { FreightEditorAudience } from '@/components/freight/freightEditorAudience'
import { FieldError } from '@/components/ui/field'
import { checksForCard, FillCard, type FillCheck } from '@/models/fillApplication'
import type { Org } from '@/models/user'
import { FillSectionCard } from '../App/Customers/FillApplication/FillSectionCard'
import { FillTabSection } from '../App/Customers/FillApplication/FillTabSection'
import { FreightField } from '../App/Customers/FillApplication/FreightField'
import type { BusinessCardForm } from '../App/Customers/FillApplication/useBusinessCardForm'

interface ConfirmBusinessCardProps {
  orgId: string
  organisation: Org
  checks: FillCheck[]
  form: BusinessCardForm
}

/** Intake's Business tab for the customer: their own details, with no owner to pick. */
export function ConfirmBusinessCard({ orgId, organisation, checks, form }: ConfirmBusinessCardProps) {
  const application = organisation.currentInsuranceApplication

  return (
    <FillTabSection
      card={FillCard.BUSINESS}
      title="Business"
      checks={checksForCard(checks, FillCard.BUSINESS)}
      saving={form.saving}
    >
      <FillSectionCard title="Business details" plain>
        <BusinessDetailsFields
          form={form.details.form}
          coverageLapseDetected={application?.coverageLapseDetected}
          lockDotNumber
          columns={2}
          idPrefix="confirm-bd"
        />
        <FieldError>{form.details.form.formState.errors.root?.server.message}</FieldError>
      </FillSectionCard>
      <FillSectionCard title="Business owner" plain>
        <OwnerInfoFields form={form.owner.form} columns={2} idPrefix="confirm-oi" />
        <FieldError>{form.owner.form.formState.errors.root?.server.message}</FieldError>
      </FillSectionCard>
      <FillSectionCard title="Travel distance" plain>
        <TravelDistanceFields form={form.distance.form} options={application?.travelDistanceOptions ?? []} />
        <FieldError>{form.distance.form.formState.errors.root?.server.message}</FieldError>
      </FillSectionCard>
      {/* Full width, so each freight type's slider has room beside its name. */}
      <FillSectionCard title="Freight" plain>
        <FreightField orgId={orgId} form={form.freight.form} audience={FreightEditorAudience.CUSTOMER} />
        <FieldError>{form.freight.form.formState.errors.root?.server.message}</FieldError>
      </FillSectionCard>
    </FillTabSection>
  )
}
